import { z } from 'zod';
import { DecimalString, IsoDate, IsoDateTime, MoneyAmount, UuidString } from '../primitives.js';

/**
 * S18 — Project Milestone. Двойная роль: billing-gate (как у Odoo
 * sale_order_line.qty_delivered_method='milestones') + Gantt-маркер (diamond).
 */

export const ProjectMilestone = z
  .object({
    id: UuidString,
    entity_id: UuidString,
    project_id: UuidString,
    position: z.number().int().nonnegative(),
    name: z.string().min(1).max(255),
    deadline: IsoDate.nullable(),
    is_reached: z.boolean().default(false),
    reached_date: IsoDateTime.nullable(),
    billing_pct: DecimalString.default('0'),
    /** Pre-computed (P11.9 JOIN sales_orders.total_amount × billing_pct/100). */
    expected_billing_amount: MoneyAmount.nullable().optional(),
    billed_invoice_id: UuidString.nullable(),
    billed_invoice_code: z.string().nullable().optional(),
    /** B5 — optional привязка к task для UX15 (visual alignment в Gantt). */
    linked_task_id: UuidString.nullable().optional(),
    notes: z.string().nullable(),
    created_at: IsoDateTime,
    updated_at: IsoDateTime,
  })
  .passthrough()
  .superRefine((d, ctx) => {
    // P6.2 — invariant: is_reached=true ⇒ reached_date != null.
    if (d.is_reached && !d.reached_date) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'milestone_reached_requires_reached_date',
        path: ['reached_date'],
      });
    }
  });
export type ProjectMilestone = z.infer<typeof ProjectMilestone>;

export const ProjectMilestoneUpsertInput = z.object({
  name: z.string().min(1).max(255),
  deadline: IsoDate.nullable().optional(),
  billing_pct: DecimalString.optional(),
  /** B5 — accept linked_task_id at create/update. Cross-project guard на BE. */
  linked_task_id: UuidString.nullable().optional(),
  notes: z.string().nullable().optional(),
});
export type ProjectMilestoneUpsertInput = z.infer<typeof ProjectMilestoneUpsertInput>;

export const ProjectMilestoneMarkReachedInput = z.object({
  reached_date: IsoDateTime.optional(),
  notes: z.string().nullable().optional(),
});
export type ProjectMilestoneMarkReachedInput = z.infer<typeof ProjectMilestoneMarkReachedInput>;

export const ProjectMilestoneReorderInput = z.object({
  new_position: z.number().int().nonnegative(),
});
export type ProjectMilestoneReorderInput = z.infer<typeof ProjectMilestoneReorderInput>;
